export function noDecimals(x: any) {
  return x.toFixed(0);
}

export function oneDecimal(x: any) {
  return x.toFixed(1);
}
